export const ecallQueueKey = (ecallId: number) => `ecall-${ecallId}`
